import axios from 'axios';
import Keycloak from 'keycloak-js';
import { getToken } from './getToken';
import MessageBus from '@restore/messagebus';
import parseOrganizationRoles from './organizationRolesParser';

export const authInterceptor = (keycloak: Keycloak, realm?: string, orgOverride?: string) => {
  if (!window.__RESTORE_fetchSet) {
    const { fetch: _fetch } = window;
    const messageBus = new MessageBus();
    const urlParams = new URLSearchParams(location.search);
    const orgQuery = urlParams.get('orgId');
    let organization = orgOverride ? orgOverride : orgQuery;

    const organizationRoles = parseOrganizationRoles(keycloak);

    if (!organization && organizationRoles) {
      organization = Object.keys(organizationRoles)[0];
    }

    messageBus.subscribe('getOrganization', (payload) => {
      if (payload && typeof payload === 'object' && 'requestID' in payload) {
        messageBus.respond('getOrganization', payload.requestID as number, organization || '');
      }
    });

    window.fetch = async (url, options): Promise<Response> => {
      const modifiedOptions = {
        ...options,
      };
      if (url.toString().includes(import.meta.env.VITE_API_SERVER)) {
        // Only attach the realm header together with a valid token. Sending
        // X-Auth-Realm without an Authorization token makes the backend treat
        // the request as an authenticated keycloak call and 500s.
        let token: string | null = null;
        try {
          token = await getToken(keycloak);
        } catch {
          token = null;
        }
        if (token) {
          modifiedOptions.headers = {
            'Content-Type': 'application/json',
            Authorization: token,
            'X-Auth-Realm': realm || 'master',
            'X-Org-Id': organization || '',
          };
        }
      }
      return _fetch(url, modifiedOptions)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          throw Error(error);
        });
    };

    axios.interceptors.request.use(async (config) => {
      const url = config.url;

      const modifiedConfig = {
        ...config,
        headers: {
          ...config.headers,
        },
      };

      if (url?.toString().includes(import.meta.env.VITE_API_SERVER) && !modifiedConfig.headers.Authorization) {
        // Only attach the realm header together with a valid token (see fetch override above).
        let token: string | null = null;
        try {
          token = await getToken(keycloak);
        } catch {
          token = null;
        }

        if (token) {
          modifiedConfig.headers.Authorization = token;
          modifiedConfig.headers['X-Auth-Realm'] = realm || 'master';
          modifiedConfig.headers['X-Org-Id'] = organization || '';
        }
      }

      return modifiedConfig;
    });

    window.__RESTORE_fetchSet = true;
  }
};
